import { useTranslation } from 'react-i18next'
import { Icon, Skeleton } from '@/ds'
import type { IconName } from '@/ds'
import { locale } from '@/lib/format'
import { useAppNavigate, withQuery } from '@/lib/query-params'
import type { ClimateMode } from '@/services/clima'
import type { StayData } from '../useStayData'

const MODE_ICON: Record<ClimateMode, IconName> = { heat: 'sun', cool: 'snowflake', auto: 'refresh-cw', off: 'power' }
const ROUTE = '/accesos/clima'

/** Tarjeta contextual de clima en Tu estancia, solo durante la estancia (prompt-clima.md; pendiente de B1 en el inventario). */
export function ClimateCard({ data, lang }: { data: StayData; lang: string }) {
  const { t } = useTranslation()
  const { go, search } = useAppNavigate()
  if (data.climate.kind === 'loading') return <Skeleton height={120} radius={16} />
  if (data.climate.kind !== 'ready') return null
  const c = data.climate.value
  const zone = c.zones[0]
  if (c.variant !== 'connected' || c.state !== 'active' || !zone || zone.current === null) return null
  const deg = (n: number) => t('v2.estancia.clima.grados', { temp: new Intl.NumberFormat(locale(lang), { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(n) })
  return (
    <div className="estancia__climate">
      <div className="estancia__climate-row">
        <Icon name={MODE_ICON[zone.mode]} size={36} className="estancia__climate-icon" />
        <div className="estancia__climate-text">
          <div className="estancia__climate-temp tnum">{deg(zone.current)}</div>
          <div className="estancia__climate-sub">{t('v2.estancia.clima.ahora', { zone: zone.name.toLowerCase(), mode: t(`v2.estancia.clima.modo.${zone.mode}`), target: zone.target !== null ? deg(zone.target) : '—' })}</div>
        </div>
      </div>
      <a
        href={withQuery(ROUTE, search)}
        onClick={(e) => {
          e.preventDefault()
          go(ROUTE)
        }}
        className="estancia__inline-link"
      >
        {t('v2.estancia.clima.cambiar')}
        <Icon name="chevron-right" size={20} />
      </a>
    </div>
  )
}
